import { createStore, createHook } from "react-sweet-state";
import { removeApi } from "../api";

const Store = createStore({
  // value of the store on initialisation
  initialState: {
    loading: true,
  },
  // actions that trigger store mutation
  actions: {
    deleteData:
      ({ _id }, onSuccess) =>
      async ({ setState, getState }) => {
        setState({ isLoading: true });

        try {
          const resp = await removeApi(_id);

          if (resp.data && resp.data.code === 200) {
            setState({
              isLoading: false,
            });
            if (onSuccess) {
              onSuccess();
            }
            return;
          }
        } catch (err) {
          setState({
            error: err && err.response ? err.response.data : "Unknown error",
          });
        }

        setState({ isLoading: false });
      },
  },
  // optional, mostly used for easy debugging
  name: "deleteSettingShiftService",
});

export const useDeleteStore = createHook(Store);
